import { z } from 'zod';
import type { CompanyType } from './corporate_id.js';

export const administrativeBodies = [
  'Board', // Styrelse
  'BoardAndDirector', // Styrelse och VD
  'DirectorOnly', // VD
  'BusinessManagement', // Företagsledning
  'Administrator', // Förvaltare
  'GeneralPartner', // Komplementär
  'Partners', // Bolagsmännen
  'SecretaryGeneral', // Generalsekreterare
] as const;
export const administrativeBodySchema = z.enum(administrativeBodies);
export type AdministrativeBody = z.infer<typeof administrativeBodySchema>;

function getValidAdministrativeBodies(
  companyType: CompanyType,
  hasManagingDirector?: boolean,
): readonly AdministrativeBody[] {
  switch (companyType) {
    case 'LimitedCompany':
    case 'EconomicAssociation':
    case 'HousingCooperativeAssociation':
      if (hasManagingDirector === undefined) {
        return ['Board', 'BoardAndDirector'];
      } else if (hasManagingDirector) {
        return ['BoardAndDirector'];
      } else {
        return ['Board'];
      }
    case 'GeneralPartnership':
      return ['Board', 'BoardAndDirector', 'BusinessManagement', 'Partners'];
    case 'LimitedPartnership':
      return ['Board', 'BoardAndDirector', 'BusinessManagement', 'GeneralPartner'];
    case 'SoleProprietorship':
      return ['Board', 'BoardAndDirector', 'DirectorOnly', 'BusinessManagement'];
    case 'NonProfitAssociation':
      return ['Board', 'BoardAndDirector', 'DirectorOnly', 'SecretaryGeneral'];
    case 'ForeignBranchWithinEES':
    case 'ForeignBranchOutsideEES':
      return ['DirectorOnly'];
    case 'PensionOrPersonnelFoundation':
    case 'FoundationWithAnnualFinancialStatements':
      return ['Board', 'Administrator'];
    case 'Authority':
    case 'Other':
      return administrativeBodies;
  }
}

export { getValidAdministrativeBodies };
